var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"festival"}},[_c('h1',[_vm._v("Festival")]),_vm._v(" "),_c('p',{staticClass:"aha-info",domProps:{"innerHTML":_vm._s(_vm.info.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }